// eslint-disable-next-line no-console

export const NODE_ENV = process.env.NODE_ENV ? `${process.env.NODE_ENV}` : '';

export const SENTRY_DSN = process.env.REACT_APP_DISPENSER_SENTRY_DSN || '';

export const API_BUSINESS_URL = process.env.REACT_APP_API_BUSINESS_URL || '';

export const API_MEMED_URL = process.env.REACT_APP_API_MEMED_URL || '';

export const MEMED_URL = process.env.REACT_APP_MEMED_URL || '';

export const MDHUB_CONTAINER_ID = 'dispenser-notification';
